query TrackingEntityDocumentData($id: UUID!) {
  entityDocument(id: $id) {
    id
    # entityId
    # _documentContents
    # _isAccountingDocument
    # _isDocumentAmountApplied
    # isAppliedAmountRetired
    # isAppliedAmountOverage
    # documentRetiredAmount
    # entityDocumentTypeId
    # fileIndexInformation
    # _isDocumentTypeUpdatable
    # _poAllocationTotal
    # comment
    # documentTypeId
    _unretirePrivilege
    _retirePrivilege
    documentTypes {
      id
      documentType
      isAccountingDocument
      isSigningRequired
      _isAppliableDocumentType
    }
    # documentStatusType {
    #   statusType
    # }
    # documentStatusExplanation
    # documentOverageAmount
    # _isDocumentAmountAvailable
    documentAppliedAmounts {
      id
      appliedTotal
      overageTotal
      retiredTotal
      usedTotal
      remainingTotal
      _isRemainingAmountAvailable
      _isRetiringBalanceAllowed
    }
    currency {
      isoCode
    }
    # _documentPoolName
    # _documentPoolId
    indexName
    indexAmount
    # indexCurrencyId
    indexDescription
    indexReferenceNumber
    # indexTransactionDate
    # _isReportingDocument
    # _sharedByUser
    # _fileName
    # _fileType
    # _createdDate
    # _isDocumentShare
    # fileReference
    # iconType
    # _fileSize
    # rowSecurityId
    # entityDocumentSecureRowLevels {
    #   id
    #   description
    #   name
    #   securityLevel
    # }
    # _uploadDate
    _rowTimestamp
    # _isLoading
    # _isDeletable
    # _isUpdatable
    # _isProtected
    # _isSelected
    # isShareable
    # _isLoadFailed
    # documentAppliedAmount
    # paymentDocument {
    #   _isApprovalDocumentsRequired
    # }
    # invoiceDocument {
    #   _isApprovalDocumentsRequired
    # }
    # extractionTypeId
  }
}
